import type { RouteRecordRaw } from 'vue-router'

const incidentH5Routes: RouteRecordRaw[] = [
  {
    path: '/t/:tenantCode/incident-assistant',
    name: 'incident-h5-assistant',
    component: () => import('@/views/incident/IncidentH5Assistant.vue'),
    meta: {
      title: '北极星故障助手',
      public: true,
    },
  },
]

export default incidentH5Routes
